<template>
<b-container fluid class="m-0 p-0">
  <b-card class="m-0 p-0" border-variant="info" :header="`조달업체 상세정보:  ${bidder.basic.corpNm}`" align="left">
    <b-card-title>
      <b-badge>상호</b-badge> {{ bidder.basic.corpNm }}
    </b-card-title>
    <b-card-text>
    <table bordered>
      <tr>
        <th>사업자등록번호</th>
        <td>{{ bidder.basic.bizno }}</td>
        <th>대표자</th>
        <td>{{ bidder.basic.ceoNm }}</td>
        <th>본지사</th>
        <td>{{ bidder.basic.hdoffceDivNm }}</td>
      </tr>
      <tr>
        <th>주소</th>
        <td colspan="5">(우){{ bidder.basic.zip }} {{ bidder.basic.cntryNm }} {{ bidder.basic.adrs }} {{ bidder.basic.dtlAdrs }}</td>
      </tr>
      <tr>
        <th>전화</th>
        <td colspan="2">{{ bidder.basic.telNo.includes('***') ? '미공개' : bidder.basic.telNo }}</td>
        <th>팩스</th>
        <td colspan="2">{{ bidder.basic.faxNo }}</td>
      </tr>
      <tr>
        <th>업종구분</th>
        <td colspan="2">{{ bidder.basic.corpBsnsDivNm }}</td>
        <th>제조구분</th>
        <td colspan="2">{{ bidder.basic.mnfctDivNm }}</td>
      </tr>
      <tr>
        <th>종업원수</th>
        <td colspan="5">{{ bidder.basic.emplyeNum }}</td>
      </tr>
      <tr>
        <th>관내</th>
        <td colspan="5">{{ bidder.basic.rgnCd }} {{ bidder.basic.rgnNm }}</td>
      </tr>
      <tr>
        <th>개업일</th>
        <td colspan="2">{{ bidder.basic.opbizDt | formatDate('YYYY-MM-DD') }}</td>
        <th>등록일</th>
        <td colspan="2">{{ bidder.basic.rgstDt  | formatDate('YYYY-MM-DD') }}</td>
      </tr>
    </table>
    </b-card-text>
    <hr/>
    <b-card-title v-if="bidder.licenses">
      등록 업종
    </b-card-title>
    <b-card-text class="m-0 p-0" align="left" v-if="bidder.licenses">
      <b-table class="m-0 p-0" 
        :items="bidder.licenses" 
        :fields="licenseFields"
        :tbody-tr-class="rowClass"
        stacked="sm" striped hover></b-table>
    </b-card-text>
    <b-card-title v-if="bidder.products">
      등록 품목
    </b-card-title>
    <b-card-text class="m-0 p-0" align="left" v-if="bidder.products">
      <b-table class="m-0 p-0"
        :tbody-tr-class="rowClass"
        :items="bidder.products" 
        :fields="productFields" 
        stacked="sm" striped hover></b-table>
    </b-card-text>
  </b-card>
</b-container>
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import moment from 'moment'
Vue.use(BootstrapVue)

export default {
  name: 'Bidder',
  props: {
    bidder: Object,
    bidder_id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selected: [],
      showContact: false,
      showDetail: false,
      licenseFields: [ 
        { key: 'indstrytyCd', label: '업종코드' },
        { key: 'indstrytyNm', label: '업종' },
        { key: 'rgstDt', label: '등록일' ,
          formatter: (value, key, item) => {
            return moment(new Date(value)).format('YYYY-MM-DD')
          } 
        },
        { key: 'chgDt', label: '갱신일' ,
          formatter: (value, key, item) => {
            if (value) {
              return moment(new Date(value)).format('YYYY-MM-DD')
            } else {
              return ''
            }
          } 
        },
        { key: 'vldPrdExprtDt', label: '유효기간',
          formatter: (value, key, item) => {
            if (value) {
              return moment(new Date(value)).format('YYYY-MM-DD')
            } else {
              return ''
            }
          }
        }, 
        { key: 'indstrytyStatsNm', label: '면허상태' },
        { key: 'rprsntIndstrytyYn', label: '대표업종' }
      ],
      productFields: [ 
        { key: 'dtilPrdctClsfcNo', label: '품목코드' },
        { key: 'dtilPrdctClsfcNoNm', label: '품명' },
        { key: 'rgstDt', label: '등록일', 
          formatter: (value, key, item) => {
            if (value) {
              return moment(new Date(value)).format('YYYY-MM-DD')
            } else {
              return ''
            }
          } 
        },
        { key: 'chgDt', label: '갱신일',
          formatter: (value, key, item) => {
            if (value) {
              return moment(new Date(value)).format('YYYY-MM-DD')
            } else {
              return ''
            }
          } 
        },
        { key: 'rprsntPrdctClsfcNoNmYn', label: '대표품목' }
      ]
    }
  },
  methods: {
    handleClick: (e) => {
      console.log(e);
    },
    detail: async function() {
      if (this.bidder_id === 0) {
        this.showDetail = !this.showDetail
      } else {
        if (this.showDetail) {
          this.showDetail = !this.showDetail
          return
        }
        try {
          const company = await this.$restBidder(this.bidder_id)
          this.bidder.licenses = company.licenses
          this.bidder.products = company.products
          this.showDetail = !this.showDetail
        } catch (err) {
          console.log(err)
        }
      }
    },
    biddersByRegion: async function() {
      const restFilters = [
        { name: 'rgnCd', op: 'eq', val: this.bidder.rgnCd }
      ]
      await this.$store.dispatch('filters/updateBidders', { restFilters: restFilters, page: 1 })
      await this.$store.dispatch('filters/updateRegion', { name: this.bidder.rgnNm, code: this.bidder.rgnCd })
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.rprsntIndstrytyYn === 'Y' || item.rprsntPrdctClsfcNoNmYn === 'Y') return 'table-danger'
    }
  }
}
</script>
<style scoped src="bootstrap/dist/css/bootstrap.css"></style>
<style scoped src="bootstrap-vue/dist/bootstrap-vue.css"></style>
